import { Link, useRouterState } from "@tanstack/react-router";
import { cn } from "@atrix-analytics/ui";

export interface SubNavItem {
  to: string;
  label: string;
  soon?: boolean;
}

/** Underlined section tabs as real links (each is its own URL). Scrolls horizontally on narrow screens. */
export function SubNav({ items, projectId, label }: { items: SubNavItem[]; projectId: string; label: string }) {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  return (
    <nav aria-label={label} className="-mx-4 overflow-x-auto border-b border-border px-4 sm:mx-0 sm:px-0">
      <ul className="flex min-w-max gap-1">
        {items.map((item) => {
          const href = item.to.replace("$projectId", projectId);
          const active = pathname === href || pathname.startsWith(`${href}/`);
          return (
            <li key={item.to}>
              <Link
                to={item.to as "/p/$projectId"}
                params={{ projectId }}
                aria-current={active ? "page" : undefined}
                className={cn(
                  "relative -mb-px flex h-10 items-center gap-1.5 border-b-2 px-3 text-sm transition-colors",
                  active ? "border-accent font-medium text-fg" : "border-transparent text-fg-muted hover:text-fg",
                )}
              >
                {item.label}
                {item.soon && <span className="text-[10px] tracking-wide text-fg-faint uppercase">Soon</span>}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
